import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import Icon from '../atoms/Icon';
import TextHeadingThree from '../atoms/TextHeadingThree';
import TextParagraph from '../atoms/TextParagraph';
import Image from '../atoms/Image';
import Card from '../../../images/creditCard_visa.svg';

//Returning the component
class CreditCard extends Component {
	render() {
		return (
			<div className={`creditCard ${this.props.CreditCardClass}`}>
				<div className="creditCard__upper">
					<Image classType="creditCard__card" alt="Card" src={Card} />
					<Icon classType="creditCard__icon icon--button fa-lg fa-trash" role="button" />
				</div>
				<div className="creditCard__lower">
					<TextHeadingThree classType="creditCard__company" text={this.props.company} />
					<TextParagraph classType="creditCard__number" text={this.props.number} />
					<TextParagraph classType="creditCard__date" text={this.props.date} />
				</div>
			</div>
		)
	}
}

//Default properties if they are not set
CreditCard.defaultProps = {
	CreditCardClass: ""
};

CreditCard.propTypes = {
	company: PropTypes.string,
	number: PropTypes.string,
	date: PropTypes.string,
}
export default CreditCard;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/CreditCard.jsx